import { GalleryConfig } from 'rangeConfig/@types';

const bestaGalleryConfig: GalleryConfig = {
  default: [
    {
      sprs: [
        { id: 'SPR-19406726' },
        { id: 'SPR-19399212' },
        { id: 'SPR-79437763' },
        { id: 'SPR-29412675' },
        { id: 'SPR-29059448' },
        { id: 'SPR-99407208' },
        { id: 'SPR-09208029' },
        { id: 'SPR-39476822' },
        { id: 'SPR-09440721' },
        { id: 'SPR-59301765' },
        { id: 'SPR-99411955' }
      ]
    }
  ]
};

export default bestaGalleryConfig;
